import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPages.css';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <Navbar cartItemCount={0} />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Sobre Nosotros</h1>
          <p className="last-updated">Sol y Luna Kiosko - Tu tienda de confianza desde hace más de una década</p>

          <section className="legal-section">
            <h2>Nuestra Historia</h2>
            <p>
              Sol y Luna Kiosko nació en 2012 con una misión clara: ofrecer productos de calidad a precios accesibles 
              en nuestra comunidad. Lo que comenzó como una pequeña tienda en la esquina de Chacabuco y Lavalle, 
              se ha convertido en un negocio sólido con tres sucursales que sirven a miles de clientes cada mes.
            </p>
            <p>
              Durante más de una década, nos hemos esforzado por mantener los mismos valores que nos caracterizaron 
              desde el inicio: integridad, confianza y servicio excepcional.
            </p>
          </section>

          <section className="legal-section">
            <h2>Nuestra Visión</h2>
            <p>
              Ser la tienda minorista de referencia en la región, reconocida por nuestra variedad de productos, 
              precios competitivos y atención personalizada. Queremos que cada cliente se sienta valorado y 
              regrese a nuestras sucursales con confianza.
            </p>
          </section>

          <section className="legal-section">
            <h2>Nuestra Misión</h2>
            <p>
              Proporcionar a nuestros clientes acceso a productos de calidad a precios justos, manteniendo 
              los más altos estándares de servicio y ética empresarial. Nos comprometemos a:
            </p>
            <ul>
              <li>Ofrecer una amplia variedad de productos para todas las necesidades</li>
              <li>Mantener precios competitivos y justos</li>
              <li>Garantizar la calidad de nuestros productos</li>
              <li>Brindar atención personalizada y amable</li>
              <li>Ser accesibles y disponibles para nuestros clientes</li>
              <li>Contribuir positivamente a nuestra comunidad</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Nuestros Valores</h2>
            
            <h3>Integridad</h3>
            <p>
              Actuamos con honestidad en todas nuestras transacciones. Nuestros precios son claros, 
              nuestros productos son auténticos y nuestras promesas son cumplidas.
            </p>

            <h3>Confianza</h3>
            <p>
              Creemos que la confianza es la base de cualquier relación comercial sólida. 
              Por eso nos esforzamos cada día por ganarnos la confianza de nuestros clientes.
            </p>

            <h3>Calidad</h3>
            <p>
              No hacemos compromisos con la calidad. Seleccionamos cuidadosamente nuestros proveedores 
              y verificamos la calidad de todos nuestros productos.
            </p>

            <h3>Servicio al Cliente</h3>
            <p>
              Nuestros clientes son nuestra prioridad. Estamos disponibles para responder preguntas, 
              resolver problemas y satisfacer necesidades.
            </p>

            <h3>Comunidad</h3>
            <p>
              Somos parte de esta comunidad y nos orgullece contribuir a su desarrollo. 
              Apoyamos iniciativas locales y mantemos precios accesibles para todos.
            </p>
          </section>

          <section className="legal-section">
            <h2>Nuestras Sucursales</h2>
            
            <h3>Sucursal Centro</h3>
            <div className="store-info">
              <p><strong>Ubicación:</strong> Chacabuco y Lavalle</p>
              <p><strong>Horario:</strong> Lunes a Viernes 8:00 AM - 8:00 PM</p>
              <p><strong>Sábado:</strong> 9:00 AM - 7:00 PM</p>
              <p><strong>Domingo:</strong> 10:00 AM - 6:00 PM</p>
            </div>

            <h3>Sucursal Norte</h3>
            <div className="store-info">
              <p><strong>Ubicación:</strong> 9 de Julio y Saavedra</p>
              <p><strong>Horario:</strong> Lunes a Viernes 8:00 AM - 8:00 PM</p>
              <p><strong>Sábado:</strong> 9:00 AM - 7:00 PM</p>
              <p><strong>Domingo:</strong> 10:00 AM - 6:00 PM</p>
            </div>

            <h3>Sucursal Sur</h3>
            <div className="store-info">
              <p><strong>Ubicación:</strong> Almafuerte y Quintana</p>
              <p><strong>Horario:</strong> Lunes a Viernes 8:00 AM - 8:00 PM</p>
              <p><strong>Sábado:</strong> 9:00 AM - 7:00 PM</p>
              <p><strong>Domingo:</strong> 10:00 AM - 6:00 PM</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Por Qué Elegirnos</h2>
            
            <h3>✓ Experiencia</h3>
            <p>Más de 10 años sirviendo a la comunidad con confianza y dedicación.</p>

            <h3>✓ Variedad</h3>
            <p>Amplio catálogo de productos que cubre todas tus necesidades cotidianas.</p>

            <h3>✓ Precios Competitivos</h3>
            <p>Mantenemos precios justos sin comprometer la calidad.</p>

            <h3>✓ Servicio Personalizado</h3>
            <p>Nuestro equipo está capacitado y dispuesto a ayudarte en cualquier momento.</p>

            <h3>✓ Presencia Local</h3>
            <p>Con tres sucursales estratégicamente ubicadas, siempre estamos cerca de ti.</p>

            <h3>✓ Plataforma En Línea</h3>
            <p>Compra desde la comodidad de tu hogar con nuestra tienda online.</p>

            <h3>✓ Métodos de Pago Flexibles</h3>
            <p>Aceptamos múltiples formas de pago para tu conveniencia.</p>
          </section>

          <section className="legal-section">
            <h2>Nuestro Compromiso Ambiental</h2>
            <p>
              Sol y Luna Kiosko está comprometida con la sostenibilidad ambiental. 
              Implementamos prácticas responsables que incluyen:
            </p>
            <ul>
              <li>Reducción de residuos mediante reciclaje</li>
              <li>Uso de bolsas reutilizables</li>
              <li>Selección de proveedores con prácticas sustentables</li>
              <li>Eficiencia energética en nuestras tiendas</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Nuestro Equipo</h2>
            <p>
              Nuestro equipo está compuesto por profesionales dedicados que comparten nuestra pasión 
              por el servicio al cliente. Cada miembro del equipo está capacitado para garantizar 
              que su experiencia con Sol y Luna Kiosko sea excepcional.
            </p>
            <p>
              Creemos en el desarrollo profesional de nuestro equipo y ofrecemos capacitación continua 
              para mantenernos en la vanguardia de la industria minorista.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contacto</h2>
            <p>¿Tiene preguntas o sugerencias? Nos encantaría escucharlas.</p>
            <div className="contact-info">
              <p><strong>Sol y Luna Kiosko</strong></p>
              <p>Email: info@solylunakiosko.com</p>
              <p>Teléfono: +54 (código) XXXXXXX</p>
              <p>WhatsApp: +54 (código) XXXXXXX</p>
              <p>Dirección Principal: Chacabuco y Lavalle, Argentina</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Síguenos en Redes Sociales</h2>
            <div className="social-links-section">
              <p>Mantente conectado con las últimas ofertas y novedades:</p>
              <ul className="social-media-list">
                <li>
                  <a href="https://www.instagram.com/solyluna_kiosko/" target="_blank" rel="noopener noreferrer">
                    📱 Instagram: @solyluna_kiosko
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=100075540712787" target="_blank" rel="noopener noreferrer">
                    f Facebook: Sol y Luna Kiosko
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;

